const GET_REMINDER_VIEW = 'inquiry/reminder/view/';
const DELETE_REMINDER_VIEW = 'inquiry/reminder/delete/';
const ADD_REMINDE = 'inquiry/reminder/reminder-add/';
const GET_REMINDERS_HISTORY = 'inquiry/reminder-history-view/';
module.exports = {

    getReminderView: function(id) {
        return window.axios.get(GET_REMINDER_VIEW + id, { params: {
                forAjax: true,
            }
        });
    },
    getReminders: function(id,  full = null) {
        return window.axios.get(GET_REMINDERS_HISTORY + id, { params: {
                forAjax: true,
                full:full,
            }
        });
    },
    deleteReminderView: function(id, inquiryId) {
        return window.axios.get(DELETE_REMINDER_VIEW + inquiryId + '/' + id, { params: {
                forAjax: true,
            }
        });
    },
    addReminderView: function(inquiryId, formData) {
        formData.append('forAjax', true);
        return window.axios.post(ADD_REMINDE + inquiryId, formData, {
            responseType: 'json', // default
        });
    },

}